<template>
	<div>
		<slot></slot>
	</div>
</template>
<script>
export default {
	name: 'msValidate',
	data() {
		return {
			listInput: []
		};
	},
	mounted() {
		const me = this;
		me.listInput = me.getListInput();
		me.listInput.forEach(item => {
			item.$on('selected', me.updateUserAction);
			item.$on('change', me.updateUserAction);
		});
	},
	beforeDestroy() {
		const me = this;
		me.listInput.forEach(item => {
			item.$off('selected', me.updateUserAction);
			item.$off('change', me.updateUserAction);
		});
	},
	computed: {},
	methods: {
		getListInput() {
			const me = this;
			let editors = me.$el.querySelectorAll('.ms-editor');
			if (editors && editors.length > 0) {
				let vueEditors = [];
				editors.forEach(item => {
					if (
						item.getVueInstance &&
						typeof item.getVueInstance == 'function'
					) {
						vueEditors.push(item.getVueInstance());
					}
				});
				return vueEditors;
			}
			return [];
		},
		updateUserAction() {
			const me = this;
			me.$emit('update:userAction', true);
		},
		/**
		 * Hàm duyệt qua các control input gọi hàm validate của từng control rồi push vào trong listError;
		 * Created by LTDAT(22.06.2020)
		 *
		 * nvnam3: Thêm data xử lí các trường hợp muốn so sánh giá trị value với một dữ liệu khác( ví dụ có nằm trong mảng không)
		 *        : isConnect xác định xem validate có cho form đang submit không
		 */
		validate(force, data = null, isConnect = false) {
			const me = this;
			me.listError = [];
			me.listInput = me.getListInput();
			me.listInput.forEach(item => {
				if (
					item.validate &&
					typeof item.validate == 'function' &&
					!item.disabled
				) {
					let validateProvider = item.errorProvider || {};
					if (!validateProvider.isValid || force) {
						validateProvider = item.validate(null, data, isConnect);
					}
					if (Array.isArray(validateProvider)) {
						validateProvider.forEach(valid => {
							me.listError.push(valid);
						});
					} else if (validateProvider.isValid) {
						me.listError.push(validateProvider);
					}
				}
			});
			if (me.listError.length > 0) {
				me.$nextTick(() => {
					me.focusFirstError();
				});
				return false;
			}
			return true;
		},
		/**
		 * Hàm dùng để focus vào ô lỗi đầu tiên
		 * Created by LTDAT(22.06.2020)
		 *  */
		focusFirstError() {
			const me = this;
			let listError = me.getListError();
			if (listError && listError[0] && listError[0].gridIns) {
				listError[0].gridIns.cellSelected(listError[0].element);
			} else {
				listError[0].element.focus();
			}
		},
		/**
		 * Lấy ra list control bị lỗi
		 * Created by LTDAT(22.06.2020)
		 */
		getListError() {
			const me = this;
			return me.listError;
		},
		/**
		 * Xóa toàn bộ trạng thái validate về ban đầu
		 * created by LTDAT(22.06.2020)
		 */
		reset() {
			const me = this;
			me.$nextTick(() => {
				me.listInput.forEach(item => {
					item.errorProvider = {};
					item.errorMulti = {};
				});
			});
		}
	}
};
</script>
